import {ACTIONS} from "@intellectability/platform-common/constants";

/** @type {import("@intellectability/platform-common/router").RouterConfig} */
const routerConfig = {
    spa: false,
    appPath: "index.php",
    routes: [
        {
            layout: "null",
            path: `?action=${ACTIONS.TEMP_PONS_MANAGE}`,
            render: () => import("../../Pages/Nursing/TempPONS/Form/TempPONSForm.svelte"),
            title: "Temporary Plan of Nursing Services"
        }
    ]
};

export default routerConfig;

